import AuthTemplate from 'src/components/atoms/authTemplate'
import { routes } from 'src/routes/routes'

import { Spin } from 'antd'

const LOADER_DELAY = 500

const LoadingApp = () => {
    const path = window.location.pathname

    const authTemplatePages = [
        routes.LOGIN,
        routes.FORGOT_PASSWORD,
        routes.RESET_PASSWORD,
        routes.DEALER_SELECTOR,
        routes.BUSINESS_UNIT_SELECTOR,
        routes.BUSINESS_UNIT_BRAND_SELECTOR,
    ]

    if (authTemplatePages.includes(path)) {
        return (
            <AuthTemplate>
                <Spin delay={LOADER_DELAY} size="large" />
            </AuthTemplate>
        )
    }

    return (
        <div className="flex h-full w-screen items-center justify-center">
            <Spin delay={LOADER_DELAY} size="large" />
        </div>
    )
}

export default LoadingApp
